import { g as __rest } from '../../../_tslib-7a01aab4.js';
import { makeObservable, observable, action } from 'mobx';

var RoundInfoStore = /** @class */ (function () {
    function RoundInfoStore() {
        this.roundId = null;
        this.duration = null;
        this.second = null;
        this.betsClosedDuration = null;
        this.restRoundInfoByGame = null;
        makeObservable(this, {
            roundId: observable,
            duration: observable,
            second: observable,
            betsClosedDuration: observable,
            restRoundInfoByGame: observable.deep,
            setRoundInfo: action.bound,
            setRoundId: action.bound,
            setDuration: action.bound,
            setSecond: action.bound,
            setBetsClosedDuration: action.bound,
            setRestRoundInfoByGame: action.bound,
        });
    }
    RoundInfoStore.prototype.setRoundInfo = function (_a) {
        var roundId = _a.roundId, duration = _a.duration, second = _a.second, betsClosedDuration = _a.betsClosedDuration, rest = __rest(_a, ["roundId", "duration", "second", "betsClosedDuration"]);
        this.setRoundId(roundId);
        this.setDuration(duration);
        this.setSecond(second);
        this.setBetsClosedDuration(betsClosedDuration);
        this.setRestRoundInfoByGame(rest);
    };
    RoundInfoStore.prototype.setRoundId = function (roundId) {
        this.roundId = roundId;
    };
    RoundInfoStore.prototype.setDuration = function (duration) {
        this.duration = duration;
    };
    RoundInfoStore.prototype.setSecond = function (second) {
        this.second = second;
    };
    RoundInfoStore.prototype.setBetsClosedDuration = function (betsClosedDuration) {
        this.betsClosedDuration = betsClosedDuration;
    };
    RoundInfoStore.prototype.setRestRoundInfoByGame = function (data) {
        this.restRoundInfoByGame = data;
    };
    return RoundInfoStore;
}());
var roundInfoStore = new RoundInfoStore();

export { RoundInfoStore, roundInfoStore };
